import {
    Observable,
    Subscriber,
    from,
    of,
} from 'rxjs';
import {
    map,
    switchMap,
    filter,
    shareReplay,
} from 'rxjs/operators';
import { PushEventType } from '@core/services/pushNotifications/types';

export function createEventSourceObservable<T>(url: string, withCredentials = false, eventTypes: PushEventType[] = []): Observable<T> {
    const $source = new Observable<any>((observer: Subscriber<any>) => {
        const eventSource = new EventSource(url, { withCredentials });

        eventSource.onmessage
            = (x): void =>
                observer.next({ type: x.type, data: x.data });

        eventTypes.forEach((eventType) => {
            eventSource.addEventListener(eventType, (x) => {
                observer.next({ type: x.type, data: x.data });
            });
        });

        return (): void => {
            eventSource.close();
        };
    });
    return $source.pipe(
        switchMap<any, any>((val) => {
            try {
                const data = JSON.parse(val.data)?.data;
                if (val.type === 'message') {
                    return from(data.Messages || []).pipe(
                        map((x) => ({ type: val.type, data: { Message: x, ErrorMessage: data.ErrorMessage, StatusCode: data.StatusCode } })),
                    );
                }
                return of({ type: val.type, data: data });
            } catch {
                return of(null);
            }
        }),
        filter((val: any) => Boolean(val) && Boolean(val.data)),
        shareReplay(),
    );
}
